import MentoringCurrentPrograms from './MentoringCurrentPrograms.vue';

export default MentoringCurrentPrograms;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/currentprograms/index.ts